/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { defineMessages } from 'react-intl';

export default defineMessages({
  createAccountLabel: {
    id: 'PayPalComponents.Connect.ConnectView.Form.actions.CreateAccount.label',
    defaultMessage: 'Create Account',
    description: 'Label of the action used to provision a new PayPal account'
  },
  redirectLinkError: {
    id:
      'PayPalComponents.Connect.ConnectView.Form.actions.CreateAccount.url.invalid',
    defaultMessage: 'The URL provided in the response was invalid.',
    description:
      'Message to display if the URL returned from the PayPal API call is invalid. This URL is used to redirect to the PayPal dashboard'
  },
  resumeConfigurationLabel: {
    id: 'PayPalComponents.Connect.ConnectView.Form.actions.FinishAccount.label',
    defaultMessage: 'Finish Account Setup',
    description:
      'Label of the action used to resume initial PayPal Connect account creation'
  }
});
